<div
  *ngIf="categories?.length > 1"
  class="category-carousel"
  [ngClass]="{ 'category-carousel__white-background': !isContentLandingPage }"
>
  <h3 *ngIf="title" class="category-carousel__title">{{ title }}</h3>

  <ng-container *ngIf="isMobile; else desktopLayout">
    <section class="category-carousel__mobile">
      <ng-container *ngFor="let category of categories | slice: 0:limit">
        <app-category-bubble
          [category]="category"
          [title]="title"
          [isMobile]="isMobile"
          [isZeroResultsPage]="isZeroResultsPage"
          [searchTerm]="searchTerm"
          (categoryClick)="navigateToCategory($event)"
        >
        </app-category-bubble>
      </ng-container>
    </section>
  </ng-container>
</div>

<ng-template #desktopLayout>
  <section
    class="category-carousel__desktop"
    [ngClass]="{
      'category-carousel-newStyle': newStyleCarousel,
      'category-carousel__two-items': categories.length === 2,
      'category-carousel__three-items': categories.length === 3
    }"
  >
    <owl-carousel-o [options]="carouselOptions" #categoryCarousel>
      <ng-container *ngFor="let category of categories | slice: 0:limit">
        <ng-template carouselSlide>
          <app-category-bubble
            [promotion]="promotion"
            [category]="category"
            [title]="title"
            [isMobile]="isMobile"
            [isZeroResultsPage]="isZeroResultsPage"
            [searchTerm]="searchTerm"
            (categoryClick)="navigateToCategory($event)"
          >
          </app-category-bubble>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </section>
</ng-template>
